import { z } from 'zod';

export const AssessmentSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1, "Title is required"),
    purpose: z.string().optional(),
    criteria: z.array(z.string()).optional(),
    description: z.string().optional(),
    workPlan: z.array(z.object({
        stage: z.string(),
        duration: z.number(),
        unit: z.string(),
    })).optional(),
    units: z.array(z.object({
        name: z.string(),
        assignments: z.array(z.object({
            auditor: z.string().optional(),
            questionDocumentIds: z.array(z.string()).optional(),
            controlIds: z.array(z.string()).optional(),
        })).optional(),
    })).optional(),
    sharedDocuments: z.array(z.object({
        name: z.string(),
        size: z.string().optional(),
        date: z.string().optional(),
        url: z.string().optional(),
    })).optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    periodType: z.string().optional(),
    periodMonths: z.number().optional(),
    teamLeader: z.string().optional(),
    teamMembers: z.array(z.string()).optional(),
    status: z.string().default('Planned'),
    /** controlId → auditor response payload (shared across assigned auditors) */
    sharedAuditorControlAnswers: z.record(z.string(), z.unknown()).optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateAssessmentSchema = AssessmentSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateAssessmentSchema = AssessmentSchema.partial();
